import { useState } from "react";


import PRJ_Clone from "../assets/PRJ_Clone.png";
import PRJ_Portfolio from "../assets/H-PRJ-Portfolio.png";
import PRJ_Techforge from "../assets/H-PRJ-Techforge.png";
import PRJ_Simple from "../assets/H-PRJ-Simple.png";
import OSINT1 from "../assets/spiderfoot.png";
import OSINT2 from "../assets/harvester.png";
import OSINT3 from "../assets/maltego.png";
import OSINT4 from "../assets/maltego2.png";
import OSINT5 from "../assets/metasploit.png";
import OSINT6 from "../assets/payload.png";
import Python_Keylogger from "../assets/Python_Keylogger.png";

interface ProjectProps {
  key: string;
  is_coming_soon: boolean;
  src: string;
  title: string;
  description: string;
  skills: string;
  github_url?: string;
  live_url: string;
  image_gallery?: string[];
}

function ImageCarousel({ images }: { images: string[] }) {
  const [index, setIndex] = useState(0);
  const next = () => setIndex((index + 1) % images.length);
  const prev = () => setIndex((index - 1 + images.length) % images.length);

  return (
    <div className="relative w-full">
      <img
        src={images[index]}
        alt={`Screenshot ${index + 1}`}
        className="rounded-t-lg w-full h-56 object-cover transition-all duration-300"
      />
      <button
        onClick={prev}
        className="absolute left-2 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white px-2 py-1 rounded"
      >
        ‹
      </button>
      <button
        onClick={next}
        className="absolute right-2 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white px-2 py-1 rounded"
      >
        ›
      </button>
    </div>
  );
}

function Project({ project }: { project: ProjectProps }) {
  

  const cn =
    "max-w-sm rounded-lg shadow-xl bg-brand-gray relative overflow-hidden border-brand-pink border-[1px] border-opacity-35 fade-in";

  const handleOpenModal = () => setIsModalOpen(true);

  return (
    <div className={cn}>
      {project.is_coming_soon && (
        <div className="absolute left-0 top-0 h-16 w-16">
          <div className="absolute left-[-36px] top-[32px] w-[170px] transform -rotate-45 bg-brand-pink text-center font-semibold py-1">
            Coming Soon
          </div>
        </div>
      )}

      {project.image_gallery && project.image_gallery.length > 0 ? (
        <ImageCarousel images={project.image_gallery} />
      ) : project.live_url ? (
        <a href={project.live_url} rel="noreferrer" target="_blank">
          <img
            className="rounded-t-lg w-full h-56 object-cover"
            src={project.src}
            alt="Project Preview"
          />
        </a>
      ) : (
        <img
          className="rounded-t-lg w-full h-56 object-cover"
          src={project.src}
          alt="Project Preview"
        />
      )}

      <div className="p-5">
        {project.live_url ? (
          <a href={project.live_url} rel="noreferrer" target="_blank">
            <h5 className="mb-2 text-xl font-bold tracking-tight">
              {project.title}
            </h5>
          </a>
        ) : (
          <h5 className="mb-2 text-2xl font-bold tracking-tight">
            {project.title}
          </h5>
        )}
        <p className="mb-3 font-normal text-gray-400">{project.description}</p>
        <p className="mb-3 text-sm">{project.skills}</p>
        <div className="flex items-center">
          {project.github_url && (
            <a
              href={project.github_url}
              rel="noreferrer"
              target="_blank"
              className="inline-flex items-center border-b-2 border-transparent text-brand-neonGreen hover:border-brand-neonGreen text-sm font-medium text-center ml-auto pb-1"
            >
              View Code
              <svg
                className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9"
                />
              </svg>
            </a>
          )}

          {project.image_gallery && project.image_gallery.length > 0 && project.key !== "project-osint-screenshots" && (
            <button
              onClick={handleOpenModal}
              className="ml-auto inline-flex items-center text-sm font-medium text-center text-brand-neonGreen border-b-2 border-transparent hover:border-brand-neonGreen"
            >
              View Images
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

const PROJECTS: Array<ProjectProps> = [
  {
    key: "project-Techforge-Website",
    is_coming_soon: false,
    src: PRJ_Techforge,
    title: "Techforge Team Project",
    description: "A fully functioning e-commerce computer hardware website with a part compatibility checker.",
    skills: "React, Mantine UI, Tailwind CSS, Laravel (PHP), MySQL, Vite, Artillery, Scrapy, Selenium",
    github_url: "https://github.com/Hasnaindev59/techforge-tp2",
    live_url: "",
  },
  {
    key: "car race and counter",
    is_coming_soon: false,
    src: PRJ_Simple,
    title: "Car race and counter",
    description: "Beginner project when first learning to code.",
    skills: "Processing, Java",
    github_url: "https://github.com/Hasnaindev59/CarRaceWithCounter",
    live_url: "",
  },
  {
    key: "facebook-clone",
    is_coming_soon: false,
    src: PRJ_Clone,
    title: "Facebook Clone",
    description: "Using Kali linux machine and nettool kit i created a clone of facebook which when people log in it logs the username and password.",
    skills: "linux, kali linux, nettool kit,shell scripting,bash scripting",
    github_url: "https://github.com/Hasnaindev59/FacebookClone/blob/main/README.md",
    live_url: "",
  },

 
  {
    key: "project-portfolio",
    is_coming_soon: false,
    src: PRJ_Portfolio,
    title: "My Portfolio",
    description: "This site showcasing my skills, experience, and projects, built from scratch.",
    skills: "React, TypeScript, Tailwind CSS, GSAP",
    github_url: "https://github.com/Hasnaindev59/portfolio-website",
    live_url: "",
  },
 
 
  {
    key: "project-osint-screenshots",
    is_coming_soon: false,
    src: "/images/osint-thumbnail.png",
    title: "OSINT Tools Showcase",
    description: "Screenshots demonstrating how I used OSINT tools like spiderfoot, google dorking, and Maltego to gather open-source intelligence.",
    skills: "OSINT, Shodan, Google Dorks, Maltego, Spiderfoot, TheHarvester, Metasploit,linux, kali linux, nettool kit,shell scripting,bash scripting",
    github_url: "https://github.com/Hasnaindev59/osint-showcase/blob/main/README.md",
    image_gallery: [OSINT1, OSINT2, OSINT3, OSINT4, OSINT5, OSINT6],
    live_url: "",
  },

{
    key: "Python_Keylogger",
    is_coming_soon: false,
    src: Python_Keylogger,
    title: "Python Keylogger",
    description: "Creating a keylogger using python to capture keystrokes and send them to an email address.",
    skills: "Python, SMTP, Keylogging, Cybersecurity",
    github_url: "https://github.com/Hasnaindev59/PythonKeylogger",
    
    live_url: "",
  },

];


export default function Projects() {
  return (
    <div
      style={{ minHeight: "calc(100vh - 90px)" }}
      className="px-6 py-6 flex flex-wrap items-start justify-evenly gap-8 max-w-7xl mx-auto"
    >
      {PROJECTS.map((p) => (
        <Project key={p.key} project={p} />
      ))}
    </div>
  );
}
function setIsModalOpen(arg0: boolean) {
  throw new Error("Function not implemented.");
}


